<template>
	<div class="card">
		<div class="card-body">
			<h4>{{tarif.full_name}}</h4>
			<hr>
			<div class="between" v-if="tarif.connect == 0">
				<span>Подключение</span>
				<span v-if="tarif.connect==0">Бесплатно</span>
				<span v-if="tarif.connect > 0">{{tarif.connect}}₽</span>
			</div>
			<div class="between" v-if="tarif.router == 'Бесплатно'">
				<span>Wi-Fi роутер</span>
				<span>Бесплатно</span>
			</div>
			<div class="price flex">
				<div class="amount">{{tarif.cost}}</div>
				<div class="currency">₽/мес</div>
			</div>
			<div class="between">
				<div class="icons">
					<div class="social-icon" v-if="tarif.internet == true">
						<em class="material-icons">wifi</em>
					</div>
					<div class="social-icon" v-if="tarif.tv == true">
						<em class="material-icons">desktop_windows</em>
					</div>
					<div class="social-icon" v-if="tarif.phone == true">
						<em class="material-icons">call</em>
					</div>
				</div>
				<button class="btn btn-success btn-round" @click="btnConnect">Подключить</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "CardTarif",
	props: {
		tarif: Object
	},
	emits: [
		"connect"
	],
	methods: {
		btnConnect() {
			this.$emit('connect', this.tarif);
		}
	}
}
</script>

<style scoped>

</style>